module.exports = __webpack_public_path__ + "media/images/us-housing-logo-1e645a84.svg";